import getSymbolFromCurrency from "currency-symbol-map";
import { Popover } from "react-bootstrap";
import { AssetDetails } from "../../@types/Posts";
import { projectPrimaryColor } from "../../generalConfigs";
import useIcons from "../../hooks/useIcons";
import { IAssetItem } from "../../interfaces/IAssetsData";
import { parseAssetTypeInt, parseCountryCodeInt } from "../../utils";

export default function AssetDetailsHover(
  assetData: IAssetItem | AssetDetails
): JSX.Element {
  const { getURI } = useIcons();
  if (!assetData) {
    return <div />;
  }

  return (
    <Popover style={{ borderRadius: 15, margin: 0, zIndex: 999, width: 450, overflow: "hidden" }}>
      <div className="animated-fast fadeInDown" style={{ backgroundColor: "var(--bg-3)" }}>
        <Popover.Header
          as="h3"
          style={{
            borderTopLeftRadius: 15,
            borderTopRightRadius: 15,
            backgroundColor: projectPrimaryColor,
            color: "white",
          }}
        >
          <div className="row">
            <div className="col-sm-1 mg-r-10">
              <img
                style={{ width: 30, height: 30, borderRadius: 50 }}
                src={getURI(assetData.icon)}
                alt="asset icon"
              />
            </div>

            <div
              className={
                //Whether the asset name could be in a single line, we add margin top.
                assetData.name.length > 21 ? "col-lg" : "col-lg mg-t-7"
              }
            >
              <span>{assetData.name}</span>
            </div>
          </div>
        </Popover.Header>
        <Popover.Body style={{
          color: "var(--text-2)",
          backgroundColor: "var(--bg-3)",
        }}>
          {assetData.symbol && (
            <div>
              <span>
                <b>Ticker:</b>
                <span className="badge badge-pill badge-secondary mg-l-2">
                  {assetData.symbol}
                </span>
              </span>
              <br />
            </div>
          )}

          {assetData.exchange && (
            <div>
              <span>
                <b>Exchange:</b>
                <span className="mg-l-5">{assetData.exchange}</span>
              </span>

              <br />
            </div>
          )}

          {assetData.type && (
            <div>
              <span>
                <b>Tipo:</b>
                <span className="mg-l-5">
                  {parseAssetTypeInt(assetData.type)}
                </span>
              </span>
              <br />
            </div>
          )}

          {assetData.currency_symbol && (
            <div>
              <span>
                <b>Moeda:</b>
                <span className="mg-l-5">
                  {`${getSymbolFromCurrency(assetData.currency_symbol)}
              (${assetData.currency_symbol})`}
                </span>
              </span>
              <br />
            </div>
          )}

          {assetData.country_code &&
            parseCountryCodeInt(assetData.country_code) && (
              <div>
                <span>
                  <b>País:</b>
                  <span className="mg-l-5">
                    {parseCountryCodeInt(assetData.country_code)}
                  </span>
                </span>
              </div>
            )}
        </Popover.Body>
      </div>
    </Popover>
  );
}
